import { memo } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import WdSvgIcon from '@main/core/WdSvgIcon';
import WdScrollbars from '@main/core/WdScrollbars';
import { NotificationCard } from './NotificationCard';

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.background.default,
    width: 320,
  },
}));

export const NotificationPanel = memo(
  ({ visibility, onClose = () => { }, onClick = () => { }, onDismiss = () => { }, onDismissAll = () => { }, notifications = [] }) => {
    const theme = useTheme();

    const handleDismiss = (notificationId) => {
      onDismiss(notificationId);
    };

    const handleDismissAll = () => {
      onDismissAll();
    };

    return (
      <StyledSwipeableDrawer
        open={visibility}
        anchor="right"
        onOpen={(ev) => console.log('on open')}
        onClose={onClose}
        disableSwipeToOpen
      >
        <div className="w-full sticky top-0 z-9999 shadow-md" style={{ backgroundColor: theme.palette.background.paper }}>
          <div className="w-full">
            <IconButton className="m-4" onClick={onClose} size="large">
              <WdSvgIcon color="action">heroicons-outline:x</WdSvgIcon>
            </IconButton>
          </div>
          <div className="flex flex-row justify-between items-center px-16 pt-36 mb-16 top-0">
            <Typography className="text-20 font-semibold leading-none">Notificaciones</Typography>
            {notifications.length > 0 && (
              <Button
                className="text-12 cursor-pointer"
                color="primary"
                onClick={handleDismissAll}
                variant="outlined"
                size="small"
                startIcon={<DeleteSweepIcon />}
              >
                Borrar todo
              </Button>
            )}
          </div>
        </div>
        {notifications.length > 0 ? (
          <WdScrollbars className="p-16">
            <div className="flex flex-col">
              {notifications.map((item) => (
                <NotificationCard
                  key={item.id}
                  className="mb-16"
                  item={item}
                  onClose={handleDismiss}
                  onClick={onClick}
                />
              ))}
            </div>
          </WdScrollbars>
        ) : (
          <div className="flex flex-1 items-center justify-center p-16">
            <Typography className="text-24 text-center" color="text.secondary">
              No hay notificaciones por ahora.
            </Typography>
          </div>
        )}
      </StyledSwipeableDrawer>
    );
  }
);
